const storeInfo = {
    path: 'storeInfo',
    name: 'storeInfo',
    component: () => import('@/layout'),
    redirect: 'noRedirect',
    meta: {
        code: 'store',
        icon: 'HSIconfont hs-icon-store',
        showRealm: ['NORMAL']
    },
    children: [
        //TODO delete after ap new version used
        {
            path: 'storeInfoAp',
            name: 'storeInfoAp',
            component: () => import('@/views/storeInfoAp'),
            meta: { code: 'store:ap' }
        },
        {
            path: 'storeInfoMap',
            name: 'storeInfoMap',
            component: () => import('@/views/storeInfoMap'),
            meta: { code: 'store:storeMap' }
        },
        {
            path: 'storeInfoEslCheck',
            name: 'storeInfoEslCheck',
            component: () => import('@/views/storeInfoEslCheck'),
            meta: { code: 'store:eslCheck' }
        }
    ]
};

export default storeInfo;
